import { useRef, useState, useEffect } from 'react'
import { Headline } from './Headline'
import styles from './Accordion.module.scss'
import parse from 'html-react-parser'

export function Accordion({
  className = '',
  items = [],
  onClose = () => {
    //
  },
  onOpen = () => {
    //
  }
}) {
  return (
    <div className={className}>
      {
        items.map((item, i) => {
          return (
            <AccordionItem
              item={item}
              onClose={onClose}
              onOpen={onOpen}
              key={i}
            />
          )
        })
      }
    </div>
  )
}

function AccordionItem({
  item,
  onClose = () => {
    //
  },
  onOpen = () => {
    //
  }
}) {
  const [ itemState, toggleActive ] = useState(item)
  const [ height, setHeight ] = useState(0)
  const content = useRef(null)

  useEffect(() => {
    if (itemState.active) {
      setTimeout(() => {
        if (content.current) {
          setHeight(content.current.scrollHeight)
        }
      }, 300) // Delay for a correct scrollHeight fetch
    } else {
      setHeight(0)
    }
  }, [itemState.active])

  function clickHandler() {
    toggleActive((prevItem) => {
      if (prevItem.active) {
        onClose(item.title)
      } else {
        onOpen(item.title)
      }

      return {
        ...prevItem,
        active: prevItem.active ? false : true
      }
    })
  }

  return (
    <dl className={`${styles.accordion__item}`}>
      <dt>
        <button className={styles.accordion__button} onClick={clickHandler}>
          <Headline tag="h5" color={item.color} className="text-[22px] md:text-[26px] text-left">{itemState.title}</Headline>
          <span  className={`${styles.accordion__toggle} ${item.color ? styles.accordion__toggle_white : ''} ${itemState.active ? styles.accordion__toggle_active : ''}`}></span>
        </button>
      </dt>
      <dd>
        <p
          ref={content}
          className={`${styles.accordion__text} ${itemState.active ? styles.accordion__text_active : ''}`}
          style={{height: height + 'px'}}
        >{ itemState.component || parse(itemState.text)}</p>
      </dd>
    </dl>
  )
}
